<div >
 <!--  *ngIf="data && data.length > 0"  -->
  <mat-dialog-content >
    <p [innerHTML]="data"></p>
  </mat-dialog-content>

  <mat-dialog-actions >
    <button mat-stroked-button mat-dialog-close color="primary">{{dismissDialogText}}</button>
  </mat-dialog-actions>
</div>
